<template>
    <div v-if="roles.is_owner && ! roles.is_public" class="btn-main-action btn-main-action--sm" data-toggle="tooltip" data-placement="top" :data-title="title">
        <button class="btn btn-primary btn-sm" @click="openModal">
            <i class="fal fa-plus tw-align-middle" aria-hidden="true" :aria-label="title"></i>
        </button>
    </div>
</template>

<script>
    import modalButtonMixin from '../../mixins/modal-button';
    export default {
        name: "AddButton",
        mixins: [modalButtonMixin],
        props: {
            title: {type: String, required: false},
            modal: {type: Object, required: false},
            modalTarget: {type: String, required: true}
        }
    }
</script>
